import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import moon from '../assets/images/moon.png'
import WorkData from '../utils/WorkData'
import { motion } from "framer-motion";

export default function Works() {

    const [workData, setWorkData] = useState(WorkData)

  return (
    <motion.div
        className='works next'
        initial={{ x: 300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 300, opacity: 0 }}
        transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        }}
    >
        {/* LEFT */}
        <div className="left">
            {/* IMAGE */}
            <div className="image">
                <div>
                    <img src={moon} />
                </div>
            </div>
            {/* TEXT */}
            <div className="text">
                <h1>Work <span>.</span></h1>
                <div className="info">
                    <span class="material-symbols-outlined">maximize</span>
                    <p>Every client is unique and so is every project. While we have delivered many web projects, <br /> we need to respect our clients' confidentiality. <br /> Here is a quick overview of our portfolio.</p>
                </div>
            </div>
        </div>
        {/* VIEW */}
        <div className="view">
            {
                workData.map(work=>{
                    return <Link to={'/details/'+work.id} className='worki'>
                                <div className="work" key={work.id} style={{flexDirection: work.id % 2 == 0 ? 'row-reverse' : 'row'}}>
                                    <img src={work.img} />
                                    <div className="info">
                                        <p>{work.name}</p>
                                        <h1>{work.id}</h1>
                                    </div>
                                </div>
                            </Link>
                })
            }
        </div>
    </motion.div>
  )
}
